// <script src='https://meet.jit.si/external_api.js'></script>
let promise = null

export default ({ Vue }) => {
	let url_main =
		'https://8x8.vc/vpaas-magic-cookie-6afe6fa648974f05a26593b85ed358c3/external_api.js'

	Vue.prototype.jitsi = function() {
		if (!promise) {
			promise = new Promise((resolve, reject) => {
				let script_main = document.createElement('script')
				script_main.async = true
				script_main.type = 'application/javascript'
				script_main.src = url_main

				script_main.onload = () => {
					resolve()
				}
				script_main.onerror = (err) => {
					reject(err)
				}

				document.body.appendChild(script_main)
			})
		}

		return promise
	}
}
